import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/shadcn/card';
import { P } from '@/components/shadcn/typography';
import { cn } from '@/utils/styles';

interface DataBoxProps {
  className?: string;
  reverse?: boolean;
  title: string;
  content?: React.ReactNode;
  titleClassName?: string;
  valueClassName?: string;
  value: number | string;
}

const DataBox = ({
  title,
  titleClassName,
  value,
  valueClassName,
  className,
  content,
  reverse,
}: DataBoxProps) => {
  return (
    <Card
      key={title}
      className={cn(
        'flex w-full flex-col gap-2 rounded-lg bg-neutral-900 p-3 md:p-6',
        {
          'flex-col-reverse': reverse,
        },
        className,
      )}>
      <CardHeader className="p-0">
        <CardTitle
          className={cn('text-xs font-thin md:text-sm', titleClassName)}>
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2 p-0 leading-none">
        <P
          className={cn(
            'text-base font-thin leading-none text-azure-400 md:text-[32px]',
            valueClassName,
          )}>
          {value}
        </P>
        {content}
      </CardContent>
    </Card>
  );
};

export default DataBox;
